import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NotificacoesMenu } from "./NotificacoesMenu";

export interface Breadcrumb {
  label: string;
  href?: string;
}

interface AppHeaderProps {
  title: string;
  breadcrumbs?: Breadcrumb[];
  onMenuClick?: () => void;
  showMenuButton?: boolean;
}

export function AppHeader({ title, breadcrumbs, onMenuClick, showMenuButton }: AppHeaderProps) {
  return (
    <header className="h-16 bg-card border-b border-border px-4 lg:px-6 flex items-center justify-between sticky top-0 z-30">
      <div className="flex items-center gap-4">
        {showMenuButton && (
          <Button variant="ghost" size="icon" className="lg:hidden rounded-full" onClick={onMenuClick}>
            <Menu className="h-5 w-5" />
          </Button>
        )}

        <div>
          {breadcrumbs && breadcrumbs.length > 0 && (
            <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-0.5">
              {breadcrumbs.map((crumb, index) => (
                <span key={index} className="flex items-center gap-1.5">
                  {index > 0 && <span className="text-border">/</span>}
                  <span
                    className={
                      index === breadcrumbs.length - 1
                        ? "text-foreground font-medium"
                        : "hover:text-foreground transition-colors cursor-pointer"
                    }
                  >
                    {crumb.label}
                  </span>
                </span>
              ))}
            </div>
          )}
          <h1 className="text-lg font-semibold text-foreground">{title}</h1>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <NotificacoesMenu triggerClassName="text-muted-foreground hover:bg-accent hover:text-foreground" />
      </div>
    </header>
  );
}
